export default __webpack_public_path__ + "static/media/CityLights01.c065110e.jpg";